import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6902f39e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content d-flex flex-column transition overflow-hidden custom-liff-div" }

import {onBeforeMount} from "vue";
import VConsole from "vconsole";
import {onMounted} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LiffLayout',
  setup(__props) {

onBeforeMount(() => {
  if(process.env.NODE_ENV !== 'production') {
    const vConsole = new VConsole()
  }
})

onMounted(() => {
  document.body.classList.toggle("dark", false)
  document.body.classList.remove("bg-body-secondary");
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})